"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LightControlsEvents;
(function (LightControlsEvents) {
    LightControlsEvents["UPDATED"] = "updated";
})(LightControlsEvents = exports.LightControlsEvents || (exports.LightControlsEvents = {}));
;
